export class  Food {
    
    public uid: string;
    public $id: string;
    public id: string;
    public brand: string;
    public counter: number;
    public defaultUnit: "string";
    public quantity: number;
    public protein: number;
    public calories: number;
    public carbs: number;
    public fat: number;
    public fiber: number;
    public defaultQuantity: number;
    public unit: string;
    public title: string;
    public sodium: number;
    public sugar: number;
    public status: "active" | "disabled";
    public foodList: boolean;
    public verified?: boolean;
    public organization: string;

    constructor (init: Partial<Food>){
        Object.assign(this, init);
    }

    getMacro(macro: string, quantity: number) {
        if(!this[macro]) {
            return 0
        } else {
            const macroVal = this[macro];
            return macroVal / this.quantity * quantity
        }
    }
}